module.exports = __webpack_public_path__ + "img/yuntuhui.0af399f3.png";